import React, { useCallback, useEffect } from "react";
import styled from "styled-components";
import { Search } from "lucide-react";
import { useClientsStore } from "./use-clients-store";

const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

const SearchWrap = styled.div`
  position: relative;
  flex: 1;
  max-width: 420px;
`;

const SearchIcon = styled.div`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  pointer-events: none;
  display: flex;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 8px 12px 8px 36px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 13px;
  outline: none;
  &:focus {
    border-color: #1976d2;
  }
`;

const StatusSelect = styled.select`
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 13px;
  outline: none;
  background: white;
  cursor: pointer;
  &:focus {
    border-color: #1976d2;
  }
`;

export const ClientsFilters: React.FC = () => {
  const { filter, setFilter, fetchClients } = useClientsStore();

  useEffect(() => {
    const timer = window.setTimeout(() => {
      fetchClients();
    }, 350);

    return () => window.clearTimeout(timer);
  }, [filter.query, fetchClients]);

  const handleSearchChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setFilter({ query: e.target.value, page: 1 });
    },
    [setFilter]
  );

  const handleSearchKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === "Enter") {
        fetchClients();
      }
    },
    [fetchClients]
  );

  const handleStatusChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      setFilter({ status: e.target.value, page: 1 });
    },
    [setFilter]
  );

  return (
    <FiltersRow>
      <SearchWrap>
        <SearchIcon>
          <Search size={16} />
        </SearchIcon>
        <SearchInput
          type="text"
          placeholder="Поиск по email, логину, телефону, ФИО..."
          value={filter.query}
          onChange={handleSearchChange}
          onKeyDown={handleSearchKeyDown}
        />
      </SearchWrap>

      <StatusSelect value={filter.status} onChange={handleStatusChange}>
        <option value="">Все статусы</option>
        <option value="active">Активные</option>
        <option value="blocked">Заблокированные</option>
        <option value="deleted">Удалённые</option>
      </StatusSelect>
    </FiltersRow>
  );
};
